export const ENDPOINT_CONSTITUTION_FIND_ALL = '/api/constitution/list';
export const ENDPOINT_CONSTITUTION_CREATE_ONE = '/api/constitution/create';
export const ENDPOINT_CONSTITUTION_UPDATE_ONE = '/api/constitution/update';
export const ENDPOINT_CONSTITUTION_DELETE_ONE = '/api/constitution/delete';
export const ENDPOINT_CONSTITUTION_FIND_ONE = '/api/constitution/getOne';
